import {
    GETWALLETDASHBOARD_SUCCESS,
    GETWALLETDASHBOARD_FAILED,
    RESET_GETWALLETDASHBOARD,
    LOADING_GETWALLETDASHBOARD,
    NETWORK_ERROR_GETWALLETDASHBOARD,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetWalletDashboard = () => {
    return { type: RESET_GETWALLETDASHBOARD };
};

const getWalletDashboard = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETWALLETDASHBOARD });
    await partnerServices
        .post("getWalletDashBoard", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getWalletDashboardsuccess(res.data));
                    break;
                default:
                    dispatch(getWalletDashboardFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETWALLETDASHBOARD, payload: err });
        });
};
function getWalletDashboardsuccess(data) {
    return {
        type: GETWALLETDASHBOARD_SUCCESS,
        payload: data,
    };
}
function getWalletDashboardFailed(data) {
    return {
        type: GETWALLETDASHBOARD_FAILED,
        payload: data,
    };
}

export { resetGetWalletDashboard, getWalletDashboard };